"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var context_1 = require("../../../../context");
var utils_1 = require("../../../../utils");
var Card_1 = require("../../../Card");
var FormControl_1 = __importDefault(require("../../../FormControl"));
var Tabs_1 = require("../../../Tabs/Tabs");
var TextArea_1 = __importDefault(require("../../../TextArea"));
var Fields_1 = require("../Fields");
exports.errorKeys = [
    'behavioural_advice_given',
    'behavioural_advice_given_other',
    'smoke_alarm_elevation',
    'smoke_alarm_elevation_other',
    'lbr_referral',
    'lbr_referral_other',
    'carbon_monoxide_alarm',
    'carbon_monoxide_alarm_other',
    'price_comparison_advice_taken',
    'price_comparison_advice_taken_other',
    'price_comparison_advice_given',
    'supplier_and_tariff_identified',
    'savings_from_switch',
];
var BehaviouralAdviceForm = function (_a) {
    var tabId = _a.tabId;
    var _b, _c, _d, _e, _f, _g;
    var trans = context_1.useSemantics().trans;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var errors = formik_1.useFormikContext().errors;
    var _h = react_1.useState(((_b = errors.project) === null || _b === void 0 ? void 0 : _b.behavioural_advice) || {}), formErrors = _h[0], setFormErrors = _h[1];
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(formErrors, exports.errorKeys)); }, [formErrors]);
    react_1.useEffect(function () { var _a; return setFormErrors(((_a = errors.project) === null || _a === void 0 ? void 0 : _a.behavioural_advice) || {}); }, [
        (_c = errors.project) === null || _c === void 0 ? void 0 : _c.behavioural_advice,
    ]);
    return (react_1.default.createElement(Card_1.Card, { heading: trans('project:slhh::headings.behavioural-advice'), subHeading: trans('project:slhh::headings.details') },
        react_1.default.createElement(Fields_1.BehaviouralAdviceInput, null),
        react_1.default.createElement(Fields_1.SmokeAlarmElevationInput, null),
        react_1.default.createElement(Fields_1.LbrReferralInput, null),
        react_1.default.createElement(Fields_1.CarbonMonoxideAlarmInput, null),
        react_1.default.createElement(Fields_1.BehaviouralAdvicePriceComparisonGivenInput, null),
        react_1.default.createElement(Fields_1.PriceAdviceInput, null),
        react_1.default.createElement(FormControl_1.default, { errors: (_e = (_d = errors.project) === null || _d === void 0 ? void 0 : _d.behavioural_advice) === null || _e === void 0 ? void 0 : _e.supplier_and_tariff_identified, label: trans('project:slhh::labels.supplier-and-tariff-identified'), help: trans('project:slhh::help.supplier-and-tariff-identified') },
            react_1.default.createElement(TextArea_1.default, { fast: true, name: "project.behavioural_advice.supplier_and_tariff_identified", maxLength: 5000 })),
        react_1.default.createElement(FormControl_1.default, { errors: (_g = (_f = errors.project) === null || _f === void 0 ? void 0 : _f.behavioural_advice) === null || _g === void 0 ? void 0 : _g.savings_from_switch, label: trans('project:slhh::labels.savings-from-switch'), flush: true },
            react_1.default.createElement(TextArea_1.default, { fast: true, name: "project.behavioural_advice.savings_from_switch", maxLength: 5000 }))));
};
exports.default = BehaviouralAdviceForm;
//# sourceMappingURL=BehaviouralAdviceForm.js.map